<script>
	import Main from "./components/Main.svelte"

	function randomColor() {
		return '#'+(Math.random() * 0xFFFFFF << 0).toString(16).padStart(6, '0');
	}
</script>

<style>
	:global(body) {
		display: flex;
		margin: 0px;
		padding: 0px;
	}

	.bg_box {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		z-index: -2;
	}

</style>

<body>
	<Main/>
	<div class="bg_box" style="background:{randomColor()}"></div>
</body>
